import {Link} from "react-router-dom";
import ContactPageLayout from "./ContactPageLayout.tsx";
import ContactStillNeedHelpComponent from "../../components/contact/ContactStillNeedHelpComponent.tsx";
import Routing from "../../Routing.ts";

export default function ContactAccountPage() {
    return (
        <ContactPageLayout
            meta_title={"Se dit abonnement på Mit Hiper"}
            meta_description={"Du kan finde information om dit abonnement på Mit Hiper. Her kan du se kontaktoplysninger, registreret betalingskort og dit login til mitwifi.dk."}
            title={"Abonnement"}
            className={"page-contact-account"}
            content={
                <>
                    <section className="contact-content">
                        <p>Du kan finde informationer om dit abonnement på <Link to={Routing.Selfcare.Index}>Mit Hiper</Link>.</p>
                        <p>I Mit Hiper kan du se:</p>
                        <ul>
                            <li>Dine kontaktoplysninger</li>
                            <li>Hvilket betalingskort du har registreret på dit abonnement</li>
                            <li>Dit log-in til <a
                                href="https://mitwifi.dk/#/login"
                                target="_blank"
                            >mitwifi.dk</a> (hvis du har internet via kabel-tv-stikket)
                            </li>
                        </ul>
                    </section>

                    <ContactStillNeedHelpComponent chat={true} form={true}/>
                </>
            }
        />
    )
}
